import { Navigate } from 'react-router-dom';
import { usePermissions } from '../../hooks/usePermissions';
import { hasFollowUpSchedulingAccessFromStorage } from '../../utils/permissionUtils';
import PageLoader from '../layout/page-loader/PageLoader';

export function FollowUpSchedulingGuard({
  children,
}: {
  children: React.ReactNode;
}) {
  const { permissions, isReady } = usePermissions();
  const storageAccess = hasFollowUpSchedulingAccessFromStorage();
  const hasAccess = isReady ? permissions.canAccessFollowUpScheduling : storageAccess;

  if (!isReady && !storageAccess) {
    return <PageLoader />
  }

  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
